"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCardCardTypeEnum = exports.CreditCardToJSON = exports.CreditCardFromJSONTyped = exports.CreditCardFromJSON = void 0;
const runtime_1 = require("../runtime");
function CreditCardFromJSON(json) {
    return CreditCardFromJSONTyped(json, false);
}
exports.CreditCardFromJSON = CreditCardFromJSON;
function CreditCardFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'number': json['number'],
        'expiration': json['expiration'],
        'cvv': json['cvv'],
        'billingZip': json['billingZip'],
        'cardType': json['cardType'],
        'cardholderName': !runtime_1.exists(json, 'cardholderName') ? undefined : json['cardholderName'],
    };
}
exports.CreditCardFromJSONTyped = CreditCardFromJSONTyped;
function CreditCardToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'number': value.number,
        'expiration': value.expiration,
        'cvv': value.cvv,
        'billingZip': value.billingZip,
        'cardType': value.cardType,
        'cardholderName': value.cardholderName,
    };
}
exports.CreditCardToJSON = CreditCardToJSON;
/**
* @export
* @enum {string}
*/
var CreditCardCardTypeEnum;
(function (CreditCardCardTypeEnum) {
    CreditCardCardTypeEnum["Visa"] = "Visa";
    CreditCardCardTypeEnum["MasterCard"] = "MasterCard";
    CreditCardCardTypeEnum["AmericanExpress"] = "AmericanExpress";
    CreditCardCardTypeEnum["Discover"] = "Discover";
    CreditCardCardTypeEnum["UNKNOWN"] = "UNKNOWN";
    CreditCardCardTypeEnum["INVALIDVALUE"] = "_INVALID_VALUE";
})(CreditCardCardTypeEnum = exports.CreditCardCardTypeEnum || (exports.CreditCardCardTypeEnum = {}));
//# sourceMappingURL=CreditCard.js.map